export default "__VITE_ASSET__BZx5arPP__"